enum AppRoutes {
  Main = "/",
  UserCabinet = "/user_cabinet",
  UserPage = "/user_page",
  RegisterPage = "/register",
  LoginPage = "/login",
  TodayPage = "/today",
  ImportPage = "/import",
}

export default AppRoutes;
